module.exports = __webpack_public_path__ + "static/media/aero1.596ef6be.jpg";